import {
  Pressable, StyleSheet, Text, View,
} from 'react-native';
import Colors from '../../constants/Colors';
import isMobile from '../IsMobile';

type SubLocationToggleSwitchProps = {
  subLocationsEnabled: boolean;
  // eslint-disable-next-line no-unused-vars
  setSubLocationsEnabled: (enabled: boolean) => void;
  assetsSelected: boolean;
};

const SubLocationToggleSwitch = ({
  subLocationsEnabled, setSubLocationsEnabled, assetsSelected,
}: SubLocationToggleSwitchProps) => (
  <View style={styles.switchContainer}>
    <Pressable
      style={(state) => [
        styles.switchButton,
        { marginRight: 4 },
        !subLocationsEnabled ? styles.switchButtonActive : {},
        (state.hovered || !subLocationsEnabled) && { borderColor: Colors.light.hereworksBlue500 },
      ]}
      onPress={() => setSubLocationsEnabled(false)}
      testID={`${assetsSelected ? 'asset' : 'sensors&meters'}-by-location-btn`}
    >
      <Text style={[
        styles.switchLabel,
        !subLocationsEnabled ? styles.switchLabelActive : {},
      ]} numberOfLines={1}>
        By Area
      </Text>
    </Pressable>
    <Pressable
      style={(state) => [
        styles.switchButton,
        subLocationsEnabled ? styles.switchButtonActive : {},
        (state.hovered || subLocationsEnabled) && { borderColor: Colors.light.hereworksBlue500 },
      ]}
      onPress={() => setSubLocationsEnabled(true)}
      testID={`all-${assetsSelected ? 'asset' : 'sensors&meters'}-btn`}
    >
      <Text style={[
        styles.switchLabel,
        subLocationsEnabled ? styles.switchLabelActive : {},
      ]}>
        {isMobile ? 'All' : `All ${assetsSelected ? 'Assets' : 'Sensors & Meters'}`}
      </Text>
    </Pressable>
  </View>
);

export default SubLocationToggleSwitch;

const styles = StyleSheet.create({
  switchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 20,
    overflow: 'hidden',
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue500,
    padding: 4,
    marginHorizontal: 12,
  },
  switchButton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#fff',
    backgroundColor: '#fff',
    borderRadius: 20,
  },
  switchButtonActive: {
    backgroundColor: Colors.light.hereworksBlue500,
  },
  switchLabel: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    color: Colors.light.hereworksBlack600,
    textAlign: 'center',
    flexWrap: 'nowrap',
  },
  switchLabelActive: {
    color: '#fff',
  },
});
